import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

const AXIS_STYLE = { fontSize: 10, fontFamily: "JetBrains Mono" };
const AXIS_TICK = { fill: "#71717a" };
const TOOLTIP_STYLE = {
  background: "#09090b",
  border: "1px solid #27272a",
  fontFamily: "JetBrains Mono",
  fontSize: 12,
};
const TOOLTIP_LABEL = { color: "#a1a1aa" };
const DOT_STYLE = { fill: "#00D4FF", r: 3 };
const ACTIVE_DOT_STYLE = { r: 5, fill: "#00D4FF" };

export default function BankrollChart({ timeline }) {
  if (!timeline || timeline.length < 2) return null;
  return (
    <div className="border border-zinc-800 p-6 mb-10">
      <div className="overline mb-4">BANKROLL CURVE</div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={timeline}>
            <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
            <XAxis
              dataKey="label"
              stroke="#71717a"
              style={AXIS_STYLE}
              tick={AXIS_TICK}
            />
            <YAxis stroke="#71717a" style={AXIS_STYLE} tick={AXIS_TICK} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={TOOLTIP_LABEL} />
            <Line
              type="monotone"
              dataKey="bankroll"
              stroke="#00D4FF"
              strokeWidth={2}
              dot={DOT_STYLE}
              activeDot={ACTIVE_DOT_STYLE}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
